export default "__VITE_ASSET__Dr0HcsV4__"